const e = {
  Log: "live-region-log",
  Status: "live-region-status",
  Alert: "live-region-alert"
};
export {
  e as LiveRegionIds
};
